import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

import { caseQuoteFailure, parseCaseQuoteId } from "helpers/case-quote";
import { quotePathById } from "helpers/me-home";
import { usePOST } from "hooks/useAPI";

/** Makes the quote of a case that has none, then opens it. A case that has
 * moved past Dispatch is reloaded instead; any other failure is reported as
 * `failed` for the page to say so. */
export function useCreateCaseQuote(caseId: string | undefined): {
  create: () => Promise<void>;
  isCreating: boolean;
  failed: boolean;
} {
  const { trigger, isMutating } = usePOST(
    caseId ? `/me/cases/${encodeURIComponent(caseId)}/quote` : "",
  );
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  const create = async () => {
    setFailed(false);
    try {
      const quoteId = parseCaseQuoteId(await trigger());
      if (quoteId === null) throw new Error("No quote id in the answer");
      await mutate("/me/home");
      navigate(quotePathById(quoteId));
    } catch (error) {
      if (caseQuoteFailure(error) === "past_dispatch") {
        await mutate(() => true);
        return;
      }
      setFailed(true);
    }
  };

  return { create, isCreating: isMutating, failed };
}
